import { BtnClasses, Button } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { NotificationEventBus } from '@trimble/solidjs-notifications';
import { Component } from 'solid-js';

export const PciExtractionSettings: Component = () => {
  const handleRun = (): void => {
    NotificationEventBus.emit({
      type: 'info',
      message: t('mobileMapping.fxWorkspace.extraction.notImplemented'),
    });
  };

  return (
    <div class="flex w-full flex-col gap-4">
      <div class="flex flex-col gap-2">
        <p
          class="m-0 text-sm text-muted"
          data-testid="pci-extraction-settings-placeholder"
        >
          {t('mobileMapping.fxWorkspace.extraction.settings.pci.placeholder')}
        </p>
      </div>
      <Button
        color={BtnClasses.PRIMARY}
        icon="tc-icon-play"
        content={t('mobileMapping.fxWorkspace.extraction.run')}
        data-cy="extraction-workflow-run-button"
        class="self-start"
        onClick={handleRun}
      />
    </div>
  );
};
